import api from "./axios";

// Watchlist — tickers the user wants to follow but doesn't own.
export const listWatchlist = () => api.get("/api/watchlist/");

export const addToWatchlist = ({ symbol, name = "", notes = "" }) =>
  api.post("/api/watchlist/", { symbol, name, notes });

export const updateWatchlistItem = (id, payload) =>
  api.patch(`/api/watchlist/${id}/`, payload);

export const removeFromWatchlist = (id) =>
  api.delete(`/api/watchlist/${id}/`);
